<div id="chartBondAndStocksPortfolio" [ngStyle]="{ 'width:': width, 'height': height }"></div>
<!-- <div id="chartBondAndStocksPortfolio" [gSstyle]="{'width: 'width}"+'; height: '+{{height}}"></div> -->
